import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import ax from "./auth/axios";
import { API_ROOT, API_ROOT1 } from "./utils/api-config";
import { connect } from "react-redux";
import { editFulfillment } from "../actions/fulfillmentAction";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import PinLocation from "./PinLocation";

const token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/json",
  },
};
class EditFulfillment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fulfillment_status: "",
      order_number: 0,
      shipto_first_name: "",
      shipto_last_name: "",
      shipto_email: "",
      shipto_phone: "",
      shipto_address1: "",
      shipto_address2: "",
      shipto_city: "",
      shipto_province: "",
      shipto_zip: "",
      total_price: 0,
      merchant_id: 0,
      custom_order: false,
      pickup: false,
      contact_customer: true,
      contact_via_sms_only: false,
      contact_via_email_only: false,
      retailers_notes: "",
      shipto_latitude: "",
      shipto_longitude: "",
      shipfrom_name: "",
      shipfrom_address1: "",
      shipfrom_zip: "",
      shipfrom_city: "",
      shipfrom_province: "",
      shipfrom_phone: "",
      shipfrom_email: "",
      shipfrom_latitude: "",
      shipfrom_longitude: "",
      number_of_bags: 0,
      order_notes: [],
      order_notes_by: [],
      order_notes_times: [],
      price: 0,
      cancelled: false,
      cancelled_by: "",
      cancelled_at: "",
      created_by: "",
      show: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.props;
    const { fulfillment } = this.props;

    this.setState({
      shipto_phone: fulfillment.shipto_phone ? fulfillment.shipto_phone : "",
      order_number: fulfillment.order_number ? fulfillment.order_number : "",
      shipto_first_name: fulfillment.shipto_first_name
        ? fulfillment.shipto_first_name
        : "",
      shipto_last_name: fulfillment.shipto_last_name
        ? fulfillment.shipto_last_name
        : "",
      shipto_email: fulfillment.shipto_email ? fulfillment.shipto_email : "",
      shipto_address1: fulfillment.shipto_address1
        ? fulfillment.shipto_address1
        : "",
      shipto_address2: fulfillment.shipto_address2
        ? fulfillment.shipto_address2
        : "",
      shipto_city: fulfillment.shipto_city ? fulfillment.shipto_city : "",
      shipto_province: fulfillment.shipto_province
        ? fulfillment.shipto_province
        : "",
      shipto_zip: fulfillment.shipto_zip ? fulfillment.shipto_zip : "",
      shipto_latitude: fulfillment.shipto_latitude
        ? fulfillment.shipto_latitude
        : "",
      shipto_longitude: fulfillment.shipto_longitude
        ? fulfillment.shipto_longitude
        : "",
      shipfrom_latitude: fulfillment.shipfrom_latitude
        ? fulfillment.shipfrom_latitude
        : "",
      shipfrom_longitude: fulfillment.shipfrom_longitude
        ? fulfillment.shipfrom_longitude
        : "",
      shipfrom_phone: fulfillment.shipfrom_phone
        ? fulfillment.shipfrom_phone
        : "",
      shipfrom_name: fulfillment.shipfrom_name ? fulfillment.shipfrom_name : "",
      shipfrom_email: fulfillment.shipfrom_email
        ? fulfillment.shipfrom_email
        : "",
      total_price: fulfillment.total_price ? fulfillment.total_price : "",
      shipfrom_name: fulfillment.shipfrom_name ? fulfillment.shipfrom_name : "",
      bdate_id: fulfillment.bdate_id ? fulfillment.bdate_id : "",
      merchant_id: fulfillment.merchant_id ? fulfillment.merchant_id : "",
      custom_order: fulfillment.custom_order ? fulfillment.custom_order : "",
      pickup: fulfillment.pickup ? fulfillment.pickup : false,
      delivery: fulfillment.pickup ? false : true,
      contact_customer: fulfillment.contact_customer
        ? fulfillment.contact_customer
        : false,
      contact_via_sms_only: fulfillment.contact_via_sms_only
        ? fulfillment.contact_via_sms_only
        : false,
      contact_via_email_only: fulfillment.contact_via_email_only
        ? fulfillment.contact_via_email_only
        : false,
      retailers_notes: fulfillment.retailers_notes
        ? fulfillment.retailers_notes
        : "",
      shipfrom_address1: fulfillment.shipfrom_address1
        ? fulfillment.shipfrom_address1
        : "",
      shipfrom_zip: fulfillment.shipfrom_zip ? fulfillment.shipfrom_zip : "",
      shipfrom_city: fulfillment.shipfrom_city ? fulfillment.shipfrom_city : "",
      shipfrom_province: fulfillment.shipfrom_province
        ? fulfillment.shipfrom_province
        : "",
      number_of_bags: fulfillment.number_of_bags
        ? fulfillment.number_of_bags
        : "",
      delivery_notes: fulfillment.delivery_notes
        ? fulfillment.delivery_notes
        : "",
      order_notes: fulfillment.order_notes ? fulfillment.order_notes : "",
      order_notes_by: fulfillment.order_notes_by
        ? fulfillment.order_notes_by
        : "",
      order_notes_times: fulfillment.order_notes_times
        ? fulfillment.order_notes_times
        : "",
      price: fulfillment.price ? fulfillment.price : "",
      return: fulfillment.return ? fulfillment.return : false,
      cancelled: fulfillment.cancelled ? fulfillment.cancelled : false,
      cancelled_at: fulfillment.cancelled_at ? fulfillment.cancelled_at : "",
      cancelled_by: fulfillment.cancelled_by ? fulfillment.cancelled_by : "",
      created_by: fulfillment.created_by ? fulfillment.created_by : "",
      fulfillment_status: fulfillment.fulfillment_status
        ? fulfillment.fulfillment_status
        : "",
    });
  }

  componentDidUpdate(prevProps) {
    const { fulfillment } = this.props;
    if (this.props.fulfillment != prevProps.fulfillment) {
      this.setState({
        shipto_latitude: fulfillment.shipto_latitude
          ? fulfillment.shipto_latitude
          : "",
        shipto_longitude: fulfillment.shipto_longitude
          ? fulfillment.shipto_longitude
          : "",
        shipfrom_latitude: fulfillment.shipfrom_latitude
          ? fulfillment.shipfrom_latitude
          : "",
        shipfrom_longitude: fulfillment.shipfrom_longitude
          ? fulfillment.shipfrom_longitude
          : "",
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleCancel = () => {
    ax.patch(
      `${API_ROOT1}/orders/cancel.json?id=${this.props.match.params.id}`,
      config
    )
      .then(({ data }) => console.log(data))
      .then(() => this.props.updateFulfillment(this.props.match.params.id));
    this.props.show();
  };

  toggleShow = () => this.setState({ show: !this.state.show });

  getToCoords = () => {
    const formData = new FormData();

    formData.append("id", this.props.match.params.id);
    formData.append("shipto_address1", this.state.shipto_address1);
    formData.append("shipto_city", this.state.shipto_city);
    ax.post(`${API_ROOT}/orders/get_coords`, formData, config)
      .then(({ data }) => console.log(data))
      .then(() => this.props.updateFulfillment(this.props.match.params.id));
  };
  getFromCoords = () => {
    const formData = new FormData();
    // let token = "Bearer " + localStorage.getItem("token");
    // const config = {
    //   headers: {
    //     Authorization: token,
    //     "Content-Type": "application/json",
    //   },
    // };
    formData.append("id", this.props.match.params.id);
    formData.append("shipfrom_address1", this.state.shipfrom_address1);
    formData.append("shipfrom_city", this.state.shipfrom_city);
    ax.post(`${API_ROOT}/orders/get_coords`, formData, config)
      .then(({ data }) => console.log(data))
      .then(() => this.props.updateFulfillment(this.props.match.params.id));
  };

  handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData();
    // let token = "Bearer " + localStorage.getItem("token");
    // const config = {
    //   headers: {
    //     Authorization: token,
    //     "Content-Type": "application/x-www-form-urlencoded",
    //   },
    // };
    this.state.delivery_instructions &&
      formData.append(
        "order[delivery_instructions]",
        this.state.delivery_instructions
      );
    this.state.delivery_notes &&
      formData.append("order[delivery_notes]", this.state.delivery_notes);
    formData.append("order[shipto_phone]", this.state.shipto_phone);
    formData.append("order[shipfrom_phone]", this.state.shipfrom_phone);
    this.state.fulfillment_id &&
      formData.append("order[fulfillment_id]", this.state.fulfillment_id);
    this.state.order_number &&
      formData.append("order[order_number]", this.state.order_number);
    this.state.shipto_first_name &&
      formData.append("order[shipto_first_name]", this.state.shipto_first_name);
    this.state.shipto_last_name &&
      formData.append("order[shipto_last_name]", this.state.shipto_last_name);
    formData.append("order[shipto_email]", this.state.shipto_email);
    this.state.shipfrom_email &&
      formData.append("order[shipfrom_email]", this.state.shipfrom_email);
    this.state.shipto_address1 &&
      formData.append("order[shipto_address1]", this.state.shipto_address1);
    this.state.shipto_address2 &&
      formData.append("order[shipto_address2]", this.state.shipto_address2);
    this.state.shipto_city &&
      formData.append("order[shipto_city]", this.state.shipto_city);
    this.state.shipto_province &&
      formData.append("order[shipto_province]", this.state.shipto_province);
    this.state.shipto_zip &&
      formData.append("order[shipto_zip]", this.state.shipto_zip);
    this.state.shipto_latitude &&
      formData.append("order[shipto_latitude]", this.state.shipto_latitude);
    this.state.shipto_longitude &&
      formData.append("order[shipto_longitude]", this.state.shipto_longitude);
    this.state.total_price &&
      formData.append("order[total_price]", this.state.total_price);
    this.state.shipfrom_name &&
      formData.append("order[shipfrom_name]", this.state.shipfrom_name);
    this.state.shipfrom_address1 &&
      formData.append("order[shipfrom_address1]", this.state.shipfrom_address1);
    this.state.shipfrom_address2 &&
      formData.append("order[shipfrom_address2]", this.state.shipfrom_address2);
    this.state.shipfrom_city &&
      formData.append("order[shipfrom_city]", this.state.shipfrom_city);
    this.state.shipfrom_province &&
      formData.append("order[shipfrom_province]", this.state.shipfrom_province);
    this.state.shipfrom_zip &&
      formData.append("order[shipfrom_zip]", this.state.shipfrom_zip);
    this.state.shipfrom_latitude &&
      formData.append("order[shipfrom_latitude]", this.state.shipfrom_latitude);
    this.state.shipfrom_longitude &&
      formData.append(
        "order[shipfrom_longitude]",
        this.state.shipfrom_longitude
      );
    this.state.shipfrom_name &&
      formData.append("order[shipfrom_name]", this.state.shipfrom_name);
    this.state.merchant_id &&
      formData.append("order[merchant_id]", this.state.merchant_id);
    this.state.driver_id &&
      formData.append("order[driver_id]", this.state.driver_id);
    this.state.route_id &&
      formData.append("order[route_id]", this.state.route_id);

    formData.append("order[pickup]", this.state.pickup);

    this.state.contact_customer &&
      formData.append("order[contact_customer]", this.state.contact_customer);
    this.state.retailers_notes &&
      formData.append("order[retailers_notes]", this.state.retailers_notes);
    this.state.number_of_bags &&
      formData.append("order[number_of_bags]", this.state.number_of_bags);
    this.state.price && formData.append("order[price]", this.state.price);
    this.state.return && formData.append("order[return]", this.state.return);
    formData.append("order[created_by]", this.state.created_by);
    formData.append("order[cancelled]", this.state.cancelled);
    formData.append("order[cancelled_by]", this.state.cancelled_by);
    formData.append("order[cancelled_at]", this.state.cancelled_at);
    this.state.drop_off_time &&
      formData.append("order[drop_off_time]", this.state.drop_off_time);
    formData.append("order[fulfillment_status]", this.state.fulfillment_status);
    formData.append("commit", "edit");

    ax.patch(
      `${API_ROOT}/orders/${this.props.match.params.id}`,
      formData,
      config
    )
      .then((response) => this.props.editFulfillment(response.data))
      .then(() => this.props.updateFulfillment(this.props.match.params.id));
    this.props.show();
  }
  render() {
    const state = this.state;
    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridMerchant">
            <Form.Label>Ship from</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipfrom_name}
              name="shipfrom_name"
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridOrderId">
            <Form.Label>Order ID</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.order_number}
              name="order_number"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridFulfillmentStatus">
            <Form.Label>Fulfillment status</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.fulfillment_status}
              name="fulfillment_status"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridPickup">
            <Form.Label>Pickup</Form.Label>
            <Form.Check
              onChange={this.handleInputChange}
              checked={state.pickup}
              name="pickup"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridCreatedBy">
            <Form.Label>Created by</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.created_by}
              name="created_by"
            />
          </Form.Group>
        </Form.Row>
        {state.pickup ? (
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFromName">
              <Form.Label> Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.shipfrom_name}
                name="shipfrom_name"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formFromEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                onChange={this.handleInputChange}
                value={state.shipfrom_email}
                name="shipfrom_email"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridFromPhone">
              <Form.Label>Customer Phone</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.shipfrom_phone}
                name="shipfrom_phone"
              />
            </Form.Group>
          </Form.Row>
        ) : (
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.shipto_first_name}
                name="shipto_first_name"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.shipto_last_name}
                name="shipto_last_name"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                onChange={this.handleInputChange}
                value={state.shipto_email}
                name="shipto_email"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPhone">
              <Form.Label>Customer Phone</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.shipto_phone}
                name="shipto_phone"
              />
            </Form.Group>
          </Form.Row>
        )}
        <Form.Row>
          {state.gift && (
            <Form.Group as={Col} controlId="formGridGiftSender">
              <Form.Label>Gift Purchasers Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.gift_sender}
                name="gift_sender"
              />
            </Form.Group>
          )}
        </Form.Row>
        <span className="font-weight-bold">Ship from:</span>
        <Form.Row>
          {!state.pickup && (
            <Form.Group as={Col} controlId="formGridFromName">
              <Form.Label> Name</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.shipfrom_name}
                name="shipfrom_name"
              />
            </Form.Group>
          )}
          <Form.Group as={Col} md="3" controlId="formGridFromAddress">
            <Form.Label>Address</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipfrom_address1}
              name="shipfrom_address1"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridFromCity">
            <Form.Label>City</Form.Label>
            <Form.Control
              name="shipfrom_city"
              onChange={this.handleInputChange}
              value={state.shipfrom_city}
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridFromState">
            <Form.Label>Province</Form.Label>
            <Form.Control
              name="shipfrom_province"
              onChange={this.handleInputChange}
              value={state.shipfrom_province}
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridFromZip">
            <Form.Label>Postal Code</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipfrom_zip}
              name="shipfrom_zip"
            />
          </Form.Group>
        </Form.Row>
        <span className="font-weight-bold">Ship to:</span>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridAddress">
            <Form.Label>Address</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipto_address1}
              name="shipto_address1"
            />
          </Form.Group>
          <Form.Group as={Col} md="3" controlId="formGridAddress2">
            <Form.Label>Apt/Suite</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipto_address2}
              name="shipto_address2"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridCity">
            <Form.Label>City</Form.Label>
            <Form.Control
              name="shipto_city"
              onChange={this.handleInputChange}
              value={state.shipto_city}
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridState">
            <Form.Label>Province</Form.Label>
            <Form.Control
              name="shipto_province"
              onChange={this.handleInputChange}
              value={state.shipto_province}
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridZip">
            <Form.Label>Postal Code</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipto_zip}
              name="shipto_zip"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridPrice">
            <Form.Label>Total Price</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.total_price}
              name="total_price"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridBags">
            <Form.Label>Number of Bags/Boxes</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.number_of_bags}
              name="number_of_bags"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridPrice">
            <Form.Label>Price, cents</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.price}
              name="price"
            />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridMap">
            <Button variant="secondary" onClick={this.toggleShow}>
              {state.show ? "Hide Map" : "Show Map"}
            </Button>
          </Form.Group>
          <Form.Group as={Col} controlId="formGridToCoord">
            <Button onClick={this.getToCoords} variant="info">
              Get ShipTo Coordinates
            </Button>
          </Form.Group>
          <Form.Group as={Col} controlId="formGridFromMap">
            <Button onClick={this.getFromCoords} variant="info">
              Get ShipFrom Coordinates
            </Button>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridLat">
            <Form.Label>Shipto Latitude</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipto_latitude}
              name="shipto_latitude"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridLng">
            <Form.Label>Shipto Longitude</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipto_longitude}
              name="shipto_longitude"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridFromLat">
            <Form.Label>Shipfrom Latitude</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipfrom_latitude}
              name="shipfrom_latitude"
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridFromLng">
            <Form.Label>Shipfrom Longitude</Form.Label>
            <Form.Control
              onChange={this.handleInputChange}
              value={state.shipfrom_longitude}
              name="shipfrom_longitude"
            />
          </Form.Group>
        </Form.Row>
        {state.show && (
          <PinLocation
            tolat={state.shipto_latitude}
            tolng={state.shipto_longitude}
            fromlat={state.shipfrom_latitude}
            fromlng={state.shipfrom_longitude}
            droplat={this.props.fulfillment.deliveries[0].drop_off_lat}
            droplng={this.props.fulfillment.deliveries[0].drop_off_lng}
          />
        )}
        {this.props.fulfillment.cancelled && (
          <Form.Row>
            <Form.Group as={Col} controlId="formGridcancelled">
              <Form.Label>Cancelled</Form.Label>
              <Form.Check
                onChange={this.handleInputChange}
                checked={state.cancelled}
                name="cancelled"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridCancelledBy">
              <Form.Label>Cancelled by</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.cancelled_by}
                name="cancelled_by"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridCancelledAt">
              <Form.Label>Cancelled at</Form.Label>
              <Form.Control
                onChange={this.handleInputChange}
                value={state.cancelled_at}
                name="cancelled_at"
              />
            </Form.Group>
          </Form.Row>
        )}

        <Button variant="primary" type="submit">
          Edit Order
        </Button>
        {!this.props.fulfillment.cancelled && (
          <Button variant="danger" onClick={this.handleCancel}>
            Cancel Order
          </Button>
        )}
      </Form>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  editFulfillment: (fulfillment) => dispatch(editFulfillment(fulfillment)),
});
export default withRouter(connect(null, mapDispatchToProps)(EditFulfillment));
